var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "7 7 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466",
    transform: "translate(-1307 -1373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(-99 -39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dollar",
    d: "M115.294,415.656a1.507,1.507,0,1,0,3.014,0,11.646,11.646,0,1,0-13.156,11.5v17.214a8.6,8.6,0,0,1-7.1-8.453,1.507,1.507,0,0,0-3.014,0,11.621,11.621,0,1,0,13.128-11.473V407.18a8.624,8.624,0,0,1,7.128,8.476Zm-17.265,0a8.621,8.621,0,0,1,7.123-8.473v16.954a8.635,8.635,0,0,1-7.123-8.481Zm17.243,20.256a8.607,8.607,0,0,1-7.106,8.453V427.456a8.61,8.61,0,0,1,7.106,8.456Zm-8.616,28.841A38.986,38.986,0,1,1,145.65,425.77,39.028,39.028,0,0,1,106.656,464.754Zm0-80.98a42,42,0,1,0,42.008,42A42.041,42.041,0,0,0,106.656,383.773Z",
    transform: "translate(1350.336 1035.227)",
    fill: "#b0beff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dollar-2",
    "data-name": "dollar",
    d: "M115.294,415.656a1.507,1.507,0,1,0,3.014,0,11.646,11.646,0,1,0-13.156,11.5v17.214a8.6,8.6,0,0,1-7.1-8.453,1.507,1.507,0,0,0-3.014,0,11.621,11.621,0,1,0,13.128-11.473V407.18a8.624,8.624,0,0,1,7.128,8.476Zm-17.265,0a8.621,8.621,0,0,1,7.123-8.473v16.954a8.635,8.635,0,0,1-7.123-8.481Zm17.243,20.256a8.607,8.607,0,0,1-7.106,8.453V427.456a8.61,8.61,0,0,1,7.106,8.456Zm-8.616,28.841A38.986,38.986,0,1,1,145.65,425.77,39.028,39.028,0,0,1,106.656,464.754Zm0-80.98a42,42,0,1,0,42.008,42A42.041,42.041,0,0,0,106.656,383.773Z",
    transform: "translate(1348.336 1037.227)",
    fill: "#4258bf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4728",
    "data-name": "Rectangle 4728",
    width: 100,
    height: 100,
    transform: "translate(1307 1373)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStep3);
export default __webpack_public_path__ + "static/media/home-step3.7c44620aee39c0c828e5914fad6a39b6.svg";
export { ForwardRef as ReactComponent };